<template>
  <v-container>
    <v-card>
      <v-card-title class="mx-3">
        DELITOS
         <v-spacer></v-spacer>
         <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          class="mr-7"
        ></v-text-field>
      </v-card-title>
      <v-btn
          color="green"
          dark
          absolute
          top
          right
          fab
          small
          @click="goToRegistrar"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      <v-data-table
        :headers="headers"
        :items="getAllDelitos"
        sort-by="id"
        :search="search"
        class="elevation-1 mx-3"
      >
        <template v-slot:item.activo="{ item }">
          <v-icon v-if="item.deleted_at"
              class="mr-2"
              color="grey"
            >
              mdi-minus
          </v-icon>
          <v-icon v-if="!item.deleted_at"
              class="mr-2"
              color="green"
            >
              mdi-check-bold
          </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            class="mr-2"
            @click="goToUpdate(item)"
            color="indigo"
          >
            mdi-pen
          </v-icon>
          <v-icon
           v-if="!item.deleted_at"
            color="red"
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
   import { mapGetters } from "vuex";
   export default {
     data() {
       return {
         dialog: false,
         search: "",
         headers: [
           { text: "Id", value:"id" ,align: "left", sortable: true },
           { text: "Nombre", value: "nombre", sortable: true },
          //  { text: "Materia", value: "materia", sortable: true },
           { text: "Activo", value: "activo", sortable: true },
           { text: "Acciones", value: "action", sortable: false }
         ]
       };
     },
     created() {
       this.$store.commit("SET_LAYOUT", "dashboard-layout");
       this.$store.dispatch("GET_ALL_DELITOS", { url: "/listDelitos" });
     },
     methods: {
       goToRegistrar() {
         this.$router.push({ name: "RegistrarDelito" });
         this.dialog = true;
       },
       goToUpdate(delito) {
         this.$store.commit("SELECT_DELITO", delito);
         this.$router.push({ name: "UpdateDelito" });
         this.dialog = true;
       },
       deleteItem(item) {
         this.$swal({
           title: '¿Desea eliminar',
           text: item.nombre + '?',
           icon: 'question',
           showCancelButton: true,
           confirmButtonText: "Aceptar"
         }).then((result) => {
           if (result.value) {
             this.save(item.id);
           }
         })
       },
       save(item) {
         this.$store.dispatch("DELETE_DELITO",  { url: "/delito/" + item } ).then(res => {
            this.$store.dispatch("GET_ALL_DELITOS", { url: "/listDelitos" });
            this.$swal({
              title: "Exito!!!",
              text: "Delito eliminado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
         });
       }
     },
     computed: {
       ...mapGetters(["getAllDelitos"])
     }
   };
</script>
